var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailsAssetsYachtType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 334,
    height: 99,
    viewBox: "0 0 334 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3416",
    "data-name": "Group 3416",
    transform: "translate(-1231 -699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_403",
    "data-name": "Rectangle 403",
    transform: "translate(1356 750)",
    fill: "#fff",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 84,
    height: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_409",
    "data-name": "Rectangle 409",
    transform: "translate(1441 750)",
    fill: "#fff",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H124a0,0,0,0,1,0,0V37a11,11,0,0,1-11,11H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h123a0,0,0,0,1,0,0V37A10.5,10.5,0,0,1,113,47.5H.5a0,0,0,0,1,0,0V.5A0,0,0,0,1,.5.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_411",
    "data-name": "Rectangle 411",
    transform: "translate(1231 750)",
    fill: "#fff",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H125a0,0,0,0,1,0,0V48a0,0,0,0,1,0,0H12A12,12,0,0,1,0,36V0A0,0,0,0,1,0,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5.5h124a0,0,0,0,1,0,0v47a0,0,0,0,1,0,0H12A11.5,11.5,0,0,1,.5,36V.5A0,0,0,0,1,.5.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_405",
    "data-name": "Rectangle 405",
    transform: "translate(1231 702)",
    fill: "#fff",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0H325a9,9,0,0,1,9,9V48a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V9A9,9,0,0,1,9,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,.5H325A8.5,8.5,0,0,1,333.5,9V47.5a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V9A8.5,8.5,0,0,1,9,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_410",
    "data-name": "Rectangle 410",
    transform: "translate(1441 750)",
    fill: "#151b47",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 123,
    height: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_412",
    "data-name": "Rectangle 412",
    transform: "translate(1231 750)",
    fill: "#151b47",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 124,
    height: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_407",
    "data-name": "Rectangle 407",
    transform: "translate(1231 702)",
    fill: "#151b47",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,0H325a9,9,0,0,1,9,9v6a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V9A9,9,0,0,1,9,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,.5H325A8.5,8.5,0,0,1,333.5,9v5.5a0,0,0,0,1,0,0H.5a0,0,0,0,1,0,0V9A8.5,8.5,0,0,1,9,.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Max_Speed",
    "data-name": "Max Speed",
    transform: "translate(1474 761)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Max Speed")), /*#__PURE__*/React.createElement("text", {
    id: "Year_Refit_Year",
    "data-name": "Year / Refit Year",
    transform: "translate(1252 761)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Year / Refit Year")), /*#__PURE__*/React.createElement("text", {
    id: "Yacht_Type",
    "data-name": "Yacht Type",
    transform: "translate(1370 712)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Yacht Type")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_408",
    "data-name": "Rectangle 408",
    transform: "translate(1356 750)",
    fill: "#151b47",
    stroke: "#151b47",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 15,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 84,
    height: 14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Crew",
    transform: "translate(1385 761)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Crew")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsAssetsYachtType);
export default __webpack_public_path__ + "static/media/detailsAssetsYachtType.671dda432e68bc82b7124040c940b365.svg";
export { ForwardRef as ReactComponent };